import { render, staticRenderFns } from "./EditPostForm.vue?vue&type=template&id=5a359ce2&scoped=true"
import script from "./EditPostForm.vue?vue&type=script&lang=js"
export * from "./EditPostForm.vue?vue&type=script&lang=js"
import style0 from "./EditPostForm.vue?vue&type=style&index=0&id=5a359ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a359ce2",
  null
  
)

export default component.exports